<template>
  <div>
    <div
      class="flex flex-row items-center gap-3 justify-between border rounded-lg selected_option p-3"
    >
      <div class="flex flex-row gap-3 items-center">
        <ThemeImage
          :icon="selectedStepDetail.icon"
          :alt="selectedStepDetail.id"
          class="size-6"
        />
        <div class="flex flex-col gap-1">
          <span class="text_color text-sm font-semibold">{{
            selectedStepDetail.title
          }}</span>
          <span class="secondary_color text-xs font-normal">{{
            selectedStepDetail.description
          }}</span>
        </div>
      </div>
      <div @click="$emit('change-step')" class="cursor-pointer min-w-[95px]">
        <span class="text-[14px] font-semibold">Change Step</span>
      </div>
    </div>

    <BaseStepConfig
      :model-value="formData"
      :step-type="formData.step_type"
      :is-first-step="stepsLength === 0"
      :sequence-id="sequenceId"
      @update:model-value="$emit('update:formData', $event)"
    />

    <QualificationConfig
      v-if="formData.step_type === sequenceStepTypes.QUALIFICATION"
      :model-value="formData"
    />

    <VoiceAgentConfig
      v-if="formData.step_type === sequenceStepTypes.VOICE"
      :model-value="formData"
      :voice-agents="voiceAgents"
    />

    <MultiThreadingConfig
      v-if="formData.step_type === sequenceStepTypes.MULTI_THREADING"
      :model-value="formData"
      :job-title-options="jobTitleOptions"
      :seniority-options="seniorityOptions"
      :department-options="departmentOptions"
      :sequences="sequences"
    />

    <TaskConfig 
      v-if="automationType === 'TASK'" 
      :model-value="formData" 
      @update:model-value="$emit('update:formData', $event)"
    />

    <LinkedinInviteConfig
        v-if="formData?.step_type === 'LINKEDIN_INVITE' && automationType !== 'TASK'"
        :model-value="formData"
    />
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { sequenceStepTypes } from "@/src/constants/sequenceConstants.js";
import OutreachService from "@/src/api/OutreachService.js";
import SequenceService from "@/src/api/SequenceService.js";
import BaseStepConfig from "@/src/components/sequences_components/configs/BaseStepConfig.vue";
import QualificationConfig from "@/src/components/sequences_components/configs/QualificationConfig.vue";
import VoiceAgentConfig from "@/src/components/sequences_components/configs/VoiceAgentConfig.vue";
import MultiThreadingConfig from "@/src/components/sequences_components/configs/MultiThreadingConfig.vue";
import TaskConfig from "@/src/components/sequences_components/configs/TaskConfig.vue";
import LinkedinInviteConfig from "@/src/components/sequences_components/configs/LinkedinInviteConfig.vue";

defineProps({
  selectedStepDetail: { type: Object, required: true },
  stepsLength: { type: Number, required: true },
  automationType: { type: String, required: true },
  formData: { type: Object, required: true },
  sequenceId: { type: [String, Number], required: false },
});

defineEmits(["update:formData", "change-step"]);

const jobTitleOptions = ref([]);
const seniorityOptions = ref([]);
const departmentOptions = ref([]);
const sequences = ref([]);

const voiceAgents = [
  { id: 1, text: "Alice" },
  { id: 2, text: "Julia" },
];

const getCampaignAllFilters = async () => {
  try {
    const response = await OutreachService.campaignAllFilters();
    if (response?.success) {
      jobTitleOptions.value = response.filters.job_title;
      seniorityOptions.value = response.filters.seniority;
      departmentOptions.value = response.filters.department;
    }
  } catch (error) {
    console.error("An error occurred while loading filters: ", error);
  }
};

const toFetchValidSequences = async () => {
  try {
    const response = await SequenceService.fetchValidSequences();
    if (response?.success) {
      sequences.value = response?.sequences;
    }
  } catch (error) {
    console.error("An error occurred while fetching sequences: ", error);
  }
};

onMounted(() => {
  getCampaignAllFilters();
  toFetchValidSequences();
});
</script>

<style scoped>
.selected_option {
  background-color: var(--white-opacity-2);
  border: 1px solid var(--white-opacity-8);
}
</style>
